import * as Models from "../.";
export interface IGetUserProfilesResponse {
  users: Array<Models.Admin.UserProfile.IUserProfile>;
  skip: number;
  take: number;
  count: number;
}

export class GetUserProfilesResponse implements IGetUserProfilesResponse {
  users: Array<Models.Admin.UserProfile.IUserProfile>;
  skip: number;
  take: number;
  count: number;
}
